var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDockRight = function SvgDockRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.7,
    viewBox: "0 0 24 24",
    className: "svgr-icon"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 14,
    x: 3,
    y: 5,
    rx: 2.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 5.4,
    height: 14,
    x: 15.2,
    y: 5,
    fill: "currentColor",
    stroke: "none",
    opacity: 0.3,
    rx: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 5v14m6.2-14v14"
  })));
};
export default SvgDockRight;